var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCallYellow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M1.49371 4.95952C2.93339 10.6147 7.38532 15.0666 13.0405 16.5063C15.1813 17.0513 17 15.2091 17 13V12C17 11.4477 16.5512 11.0053 16.0016 10.9508C15.073 10.8587 14.1818 10.6397 13.3456 10.3112L11.8263 11.8305C9.3553 10.648 7.35202 8.64471 6.16949 6.17367L7.68877 4.65438C7.36032 3.81816 7.14126 2.92696 7.04922 1.99842C6.99474 1.44883 6.55229 1 6 1H5C2.79086 1 0.948692 2.81867 1.49371 4.95952Z",
    stroke: "#FFC800",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallYellow);
export default __webpack_public_path__ + "static/media/call_yellow.cf598f756372779195c21e5a4fe1f5ac.svg";
export { ForwardRef as ReactComponent };